
<template>
  <div>
    <div class="bunder">
      <Mastermap :imgSrc='masterMap.imgSrc' :companyName='masterMap.companyName' :masterTitle='masterMap.masterTitle'>
      </Mastermap>
    </div>
    <TabBar :items='myLinks' @func='getClickI'></TabBar>
    <!-- 公司简介 -->
    <transition name="fade">
    <div class="company" v-show="TabBarShow === 0" transition='fade'>
      <div class="top">
        <div class="left">
          <h3>{{company.title}}</h3>
          <div class="line"></div>
          <p>{{company.subTitle1}}</p>
          <p>{{company.subTitle2}}</p>
          <div class="spin">
            <div class="s_left"></div>
            <div class="s_right"></div>
          </div>
        </div>
        <img :src="company.imgSrc" alt="">
      </div>
      <div class="bottom">
        <h2>{{history.title}}</h2>
        <p>{{history.subTitle}}</p>
        <div class="container_b">
          <div class="list_l">
            <div class="item_left" v-for="(item,i) in history.list_l" :key="i">
              <h2>{{item.time_l}}</h2>
              <p>{{item.content_l}}</p>
            </div>
          </div>
          <div class="list_c">
            <div class="item_center" v-for="(item,i) in 7" :key="i">
              <div></div>
            </div>
            <div class="item_center_b" >
              <div></div>
            </div>
          </div>
          <div class="list_r">
            <div class="item_right" v-for="(item,i) in history.list_r" :key="i">
              <h2>{{item.time_r}}</h2>
              <p>{{item.content_r}}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
    </transition>
    <!-- 资质证书 -->
    <transition name="fade">
    <div class="certification" v-show="TabBarShow === 1" transition='fade'>
      <div class="container">
        <div class="item" v-for="(item, i) in certificationList" :key="i">
          <img :src="item.imgSrc" alt="证书">
        </div>
      </div>
    </div>
    </transition>
    <!-- 软著专利 -->
    <transition name="fade">
    <div class="patent" v-show="TabBarShow === 2" transition='fade' >
        <div class="container">
        <div class="item" v-for="(item, i) in patentList" :key="i">
          <img :src="item.imgUrl" alt="软著专利">
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import Mastermap from '../components/Mastermap.vue'
import TabBar from '../components/TabBar.vue'
export default {
  name: 'About',
  components: { Mastermap, TabBar },
  data () {
    return {
      TabBarShow:0,
      masterMap: {
        imgSrc: require('../assets/img/aboutUs.jpg'),
        companyName: '北京赛博星通科技有限公司',
        masterTitle: '记忆点源于与众不同，专业感源于整齐划一',
      },
      myLinks: [
        {
          link: '公司简介',
          activated: true
        },
        {
          link: '资质证书',
          activated: false
        },
        {
          link: '专利软著',
          activated: false
        }
      ],
      company: {
        title: '北京赛博星通科技有限公司',
        subTitle1: '北京赛博星通科技有限公司成立于2015年。公司是以软、 硬件研发和系统集成为核心，围绕智慧城市和工业互联网两大业务板块，集自主研发、解决方案设计、生产制造、销售服务于一体，为政府和企业提供IT整体解决方案的国家高新技术企业和双软企业。',
        subTitle2: '赛博星通坚持“技术创新”的战略目标，不断在技术和应用上进行创新与突破，共取得十余项专利，20余项软件著作权，近两年作为联合体先后承担了两项国家级科研项目。',
        imgSrc: require('../assets/img/company_profile.png')
      },
      history: {
        title: '发展历程',
        subTitle: '2015年成立至今',
        list_l: [
          {
            time_l: '2021.07',
            content_l: '通过国家高新技术企业认定',
          },
          {
            time_l: '2020.08',
            content_l: '通过中关村高新技术企业认定',
          },
          {
            time_l: '2018.07',
            content_l: '南干渠阀井远程无线监测系统通过国家检测机构认定',
          },
          {
            time_l: '2015.08',
            content_l: '公司成立',
          }
        ],
        list_r: [
          {
            time_r: '2021.04',
            content_r: '成为北京市软件和信息服务协会理事会会员单'
          },
          {
            time_r: '2019.12',
            content_r: '城市运行管理平台发布'
          },
          {
            time_r: '2017.09',
            content_r: '公司第一款物联网产品南干渠阀井远程无线监测系统发布'
          }
        ]
      },
      certificationList:[
        {
          imgSrc:require('../assets/img/certification1.png')
          },
          {
          imgSrc:require('../assets/img/certification2.png')
          }, 
         
          
          {
          imgSrc:require('../assets/img/certification13.png')
          },
          {
          imgSrc:require('../assets/img/certification14.png')
          },
          {
          imgSrc:require('../assets/img/certification15.png')
          },
          {
          imgSrc:require('../assets/img/certification9.png')
          },
          {
          imgSrc:require('../assets/img/certification10.png')
          },
          {
          imgSrc:require('../assets/img/certification11.png')
          },
          {
          imgSrc:require('../assets/img/certification12.png')
          },
           {
          imgSrc:require('../assets/img/certification4.png')
          },
          {
          imgSrc:require('../assets/img/certification5.png')
          },
          {
          imgSrc:require('../assets/img/certification7.png')
          },
          {
          imgSrc:require('../assets/img/certification8.png')
          },
      ],
      patentList:[
        {
          imgUrl:require('../assets/img/patent1.png')
        },
        {
          imgUrl:require('../assets/img/patent2.png')
        },
        {
          imgUrl:require('../assets/img/patent3.png')
        },
        {
          imgUrl:require('../assets/img/patent4.png')
        },
        {
          imgUrl:require('../assets/img/patent5.png')
        },
        {
          imgUrl:require('../assets/img/patent6.png')
        },
        {
          imgUrl:require('../assets/img/patent7.png')
        },
        {
          imgUrl:require('../assets/img/patent8.png')
        },
        {
          imgUrl:require('../assets/img/patent9.png')
        },
        {
          imgUrl:require('../assets/img/patent10.png')
        },
        {
          imgUrl:require('../assets/img/patent11.png')
        },
        {
          imgUrl:require('../assets/img/patent12.png')
        }
      ]

    }
  },
  methods: {
    getClickI(index) {

      this.TabBarShow = index
      console.log(this.TabBarShow)
    }
  },
}
</script>

<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
// 公司简介
.company {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  .top {
    margin-top: 40px;
    display: flex;
    flex-direction: row;
    width: 1200px;
    background-color: #fff;
    .left {
      padding: 40px;
      width: 580px;
      height: 460px;
      h3 {
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: bold;
      }
      .line {
        margin-bottom: 40px;
        width: 40px;
        height: 4px;
        background-color: #002fa7;
      }
      p {
        margin-top: 20px;
        color: #303133;
        font-size: 16px;
        line-height: 32px;
      }
      .spin {
        display: flex;
        flex-direction: row;
        margin-top: 50px;
        div {
          width: 30px;
          height: 30px;
          border-radius: 15px;
        }
        .s_left {
          background: #002fa7;
        }
        .s_right {
          margin-left: -5px;
          background: #1039fe;
          opacity: 0.1;
        }
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1200px;
    color: #fff;
    padding-top: 60px;
    background: linear-gradient(180deg, #494972 0%, #23233e 100%);
    .container_b {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 40px;
      h2 {
        font-size: 38px;
        font-weight: bold;
      }
      p {
        font-size: 14px;
      }
      .list_l {
        display: flex;
        flex-direction: column;
        margin-top: 40px;
        h2 {
          text-align: right;
        }
        p {
          width: 280px;
          text-align: right;
        }
        .item_left {
          margin-bottom: 100px;
          height: 140px;
        }
      }
      .list_c {
        display: flex;
        flex-direction: column;
      }
      .list_r {
        display: flex;
        flex-direction: column;
        margin-top: 160px;
        h2 {
          text-align: left;
        }
        p {
          width: 280px;
          text-align: left;
        }
        .item_right {
          margin-bottom: 100px;
          height: 140px;
        }
      }
      .item_center, .item_center_b {
        position: relative;
        margin: 0 40px;
        width: 2px;
        height: 120px;
        background-color: #606266;
        div {
          position: absolute;
          bottom: 50px;
          left: -4px;
          width: 8px;
          height: 8px;
          border-radius: 8px;
          background-color: #1039fe;
          border: solid 2px #dee3ff;
        }
      }
      .item_center_b {
        height: 70px;
        div {
          bottom: 0;
          background-color: #DEE3FF;
        }
      }
      .list_r {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
// 资质证书
.certification, .patent {
  display: flex;
  justify-content: center;
  margin-top:60px ;
  .container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 1200px;
    background-color: #fff;
    padding-bottom: 60px;
    .item {
      width: 372px;
      height: 286px;
      overflow: hidden;
      img {
        width: 100%;
        transition: all 0.2s;
      }
      img:hover{
        transform: scale(1.2); 
      }
    }
  }
}
// 专利软著

</style>
